import Flickity from 'flickity'
import { getData } from 'modules/dom'
import { identity, pipe, returnFalse, tryCatch } from 'modules/utils'

const PROP_SETTINGS = 'settings'

const parseSettings = pipe(
  getData(PROP_SETTINGS),
  tryCatch(
    (string) => JSON.parse(string),
    returnFalse
  ),
)

export default el => {
  const defaults = {
    prevNextButtons: false,
    pageDots: false,
  }
  const settings = parseSettings(el) || {}
  const args = Object.assign({}, defaults, settings)

  return new Flickity(el, args)
}
